module.exports = __webpack_public_path__ + "img/resp_text_big2.870539ab.png";